<template>
  <div class="containPcBox">
    <Header @searchText="searchText"/>
    <div class="containPcTemplate" :style="$route.name=='zt'?'background:white':''">
      <router-view ref="servicePageSearch"/>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from "./myHeader";
import Footer from "./myFooter";
import {myMixin} from '@/mixins/tool.js'

export default {
  name: "pc",
  components: {
    Header,
    Footer,
  },
  mixins: [myMixin],
  created() {
    document.title = "南京信息工程大学-网上办事大厅";
  },
  methods: {
    searchText(val) {
      this.$router.push('/workflow/servicecenter');
      setTimeout(() => {
        this.$refs['servicePageSearch'].toSearch(val);
      }, 100);
    }
  }
};
</script>
<style lang="less">
@import "~@/assets/todoCenter/default/css/taskcenter.less";

.containPcTemplate {
  width: 100%;
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/index.vue